module.exports = __webpack_public_path__ + "static/media/instagram-11.930ab2cc.svg";